import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

(function () {
    // console.log('global');

    /**
     * copyData
     * @param {*} data
     */
    window.copyData = (data) => {
        return data ? JSON.parse(JSON.stringify(data)) : data;
    };

    // Returns the version of Internet Explorer or a -1
    // (indicating the use of another browser).
    window.ieVer = function getInternetExplorerVersion () {
        var rv = -1, // Return value assumes failure.
            ua,
            re;

        if (navigator.appName === 'Microsoft Internet Explorer') {
            ua = navigator.userAgent;
            re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        }

        return rv;
    };

    window.isAtLeastIE11 = !!(navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/));

    if (window.ieVer > 0 || window.isAtLeastIE11) {
        window.isIE = true;
    }

    window.serverless = location.hostname === 'localhost' ? true : false;

    /** get component of DOM
     * TODO: descriptiton
     */
    window.getVueComp = (dom) => {
        dom = dom[0];
        var key,
            comp;

        for (key in dom) {
            if (key.indexOf('__vue') !== -1) {
                comp = dom[key];

                return comp;
            }
        }

        return null;
    };


    window.addCommas = function (value) {
        if (typeof value === 'number') {
            return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        } else {
            return value;
        }
    };
    window.formatLargeNumber = function (value) {
        var round = {
                T: 0.000000000001,
                B: 0.000000001,
                M: 0.000001,
                K: 0.001
            },
            roundKey;

        if (value) {
            if (value.toString().length >= 4) {
                if (value.toString().length >= 13) {
                    //if trillions
                    roundKey = 'T';
                } else if (value.toString().length >= 10) {
                    //if billions
                    roundKey = 'B';
                } else if (value.toString().length >= 7) {
                    //if millions
                    roundKey = 'M';
                } else if (value.toString().length >= 4) {
                    //if thousands
                    roundKey = 'K';
                } else {
                    value = window.addCommas(value);
                }

                if (roundKey) {
                    value = value * round[roundKey];
                    value = Math.round(value * 10) / 10;
                    value = value + roundKey;
                }
            } else {
                value = window.addCommas(value);
            }
        } else {
            value = window.addCommas(value);
        }

        return value;
    };

    window.formatLargeCurrency = function (value) {
        if (value) {
            return '$' + window.formatLargeNumber(value);
        }

        return value;
    };

    window.loadData = ({
        url: url,
        callback: callback
    }) => {
        var xhr = new XMLHttpRequest(),
            fullURL,
            data;

        if (window.serverless || location.host.indexOf('localhost') !== -1) {
            if (url.indexOf('?') !== 0) {
                url = url.split('?')[0];
            }

            if (location.host.indexOf('localhost') !== -1) {
                fullURL = '/data/' + url + '.json';
            } else {
                fullURL = '/sites/report/themes/custom/report-cms/dist/data/' + url + '.json';
            }
        } else {
            fullURL = location.protocol + '//' + location.host + url;

        }

        xhr.open('GET', fullURL, true);
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhr.onload = () => {
            // analytics.trackTiming({
            //     category: 'Search Service',
            //     variable: url,
            //     timeStamp: 'search'
            // });

            if (xhr.status === 200) {
                data = JSON.parse(xhr.response);

                if (callback) {
                    callback(data);
                }
            } else {
                // if (!window.serverless) {
                //     window.serverless = true;

                //     window.loadData({
                //         url: url,
                //         callback: callback
                //     });
                // } else {
                if (callback) {
                    callback(xhr);
                }
                // }
            }
        };

        xhr.onerror = () => {
            // if (!window.serverless) {
            //     window.serverless = true;

            //     window.loadData({
            //         url: url,
            //         callback: callback
            //     });
            // } else {
            if (callback) {
                callback(xhr);
            }
            // }
        };

        // analytics.setTimestamp('search');

        xhr.send();
    };

    window.postData = ({
        url: url,
        datain: datain,
        callback: callback
    }) => {
        var xhr = new XMLHttpRequest(),
            fullURL,
            data;

        if (window.serverless || location.host.indexOf('localhost') !== -1) {
            if (url.indexOf('?') !== 0) {
                url = url.split('?')[0];
            }

            if (location.host.indexOf('localhost') !== -1) {
                fullURL = '/data/' + url + '.json';
            } else {
                fullURL = '/sites/report/themes/custom/report-cms/dist/data/' + url + '.json';
            }
        } else {
            fullURL = location.protocol + '//' + location.host + url;
        }

        xhr.open('POST', fullURL, true);
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhr.onload = () => {

            if (xhr.status === 200) {
                data = JSON.parse(xhr.response);

                if (callback) {
                    callback(data);
                }
            } else {

                if (callback) {
                    callback(xhr);
                }

            }
        };

        xhr.onerror = () => {

            if (callback) {
                callback(xhr);
            }

        };

        // analytics.setTimestamp('search');

        xhr.send(JSON.stringify(datain));
    };
})();